import axios from 'axios'

export default {
    async updateUserTheme(themeId) {
        try {            
            const response = await axios.post(`MyDashboardTheme/${themeId}`)                     
            return response
        }catch (error){
            console.log('MyDashboardTheme api updateUserTheme error')
            throw error
        }
    }
}